import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header"
import FloatingActionButton from "../components/FloatingActionButton";
import "../css/Home.css";


const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className={`main-layout ${sidebarOpen ? "sidebar-open" : ""}`}>
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <main className="content">{children}</main>
      <FloatingActionButton />
    </div>
  );
};

export default MainLayout;
